module.exports = __webpack_public_path__ + "img/logo-mobile.f0a15c34.svg";